import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

export const enGb = {
  ACCESS_DENIED: 'Access denied.',
  ACCOUNT_SELECTION_VIEW_TITLE: 'Account selection',
  APPROVE_YOUR_PAYMENT_IN_APP: 'Please approve the $t(SUBJECT)',
  AUTHENTICATION_METHOD: 'Authentication Method',
  AUTHENTICATION_METHOD_VIEW_TITLE: 'Authentication method',
  AWAITING_DECOUPLED_AUTHORISATION_VIEW_TITLE: 'Awaiting authorisation',
  CANCEL_PAYMENT: 'Cancel $t(SUBJECT)',
  CHIP_TAN_HEADER: 'chipTAN',
  CHIP_TAN_SUBHEADER: 'Use your chipTAN generator device',
  CLOSE_CANCEL_MODAL: 'Close cancel $t(SUBJECT) window',
  CODE_IS_NOT_WORKING: 'The code is not working',
  CONFLICT: 'Conflict.',
  CONTINUE: 'Continue',
  CONTINUE_TO_YOUR_BANK: 'Continue to your bank',
  HIDE_PASSWORD: 'Hide password / PIN',
  I_DID_NOT_RECEIVE_CODE: 'I didn’t receive the code',
  I_DO_NOT_HAVE_MY_DEVICE: 'I don’t have my device at hand',
  I_DO_NOT_REMEMBER_MY_BANK_CREDENTIALS:
    'I don’t remember my bank login credentials',
  I_WANT_TO_PAY_ANOTHER_WAY: 'I want to pay another way',
  INTERNAL_SERVER_ERROR: 'Something went wrong. Please contact support.',
  LOADING_BANK_INFORMATION: 'Loading bank information',
  LOG_IN: 'Log in to bank',
  LOGIN_VIEW: 'Login view',
  LOGIN_VIEW_TITLE: 'Login',
  M_TAN_HEADER: 'mTAN',
  M_TAN_SUBHEADER: 'Receive your TAN by SMS',
  MASKED_IBAN_ACCESSIBLE:
    'Masked IBAN starting with {{prefix}} and ending with {{suffix}}',
  MY_AUTHENTICATION_METHOD_IS_NOT_DISPLAYED:
    'My authorisation method is not displayed',
  MY_BANK_ACCOUNT_IS_NOT_DISPLAYED: 'My bank account is not displayed',
  NETWORK_ERROR: 'Connection error. Check your connection and try again.',
  OOPS_IT_APPEARS_THERE_IS_AN_ISSUE:
    "Oops, it appears there's an issue. Please reload the page.",
  OPEN_CANCEL_MODAL: 'Open cancel $t(SUBJECT) window',
  OTHER: 'Other',
  PAGE_LOADING: 'Page loading - please wait.',
  PASSWORD: 'Password / PIN',
  PAYING_WITH: 'Paying with',
  PHOTO_OTP_CHALLENGE_IMAGE_DESCRIPTION:
    'Photo OTP (One time password) code image',
  PHOTO_OTP_FALLBACK_IMAGE_DESCRIPTION:
    'We couldn’t display your image code. Please refresh the page or cancel the $t(SUBJECT).',
  PHOTO_TAN_HEADER: 'photoTAN',
  PHOTO_TAN_SUBHEADER: 'Scan a colour graphic with app or reader',
  PLEASE_USE_SAME_LOGIN_DETAILS:
    "Please use the same login details as you would use in your bank's app or website.",
  PROVIDE_VALID_LOGIN_DETAILS_TO_CONTINUE:
    'Provide valid login details to continue',
  PROVIDE_VALID_VERIFICATION_CODE_TO_CONTINUE: 'Provide valid code to continue',
  PUSH_TAN_HEADER: 'pushTAN',
  PUSH_TAN_SUBHEADER: 'Authenticate using your secure app',
  REDIRECT_OTP_HEADER: 'Redirect',
  REDIRECT_OTP_SUBHEADER:
    'Continue to the secure page to get your one-time code',
  REDIRECT_VIEW_TITLE: 'Redirecting away',
  RESOURCE_NOT_FOUND: 'Resource not found.',
  RESOURCE_NOT_MODIFIABLE:
    'SCA credentials provided for non-embedded $t(SUBJECT).',
  RETRY_LIMIT_EXCEEDED: 'The retry limit has been reached. SCA failed.',
  SCAN_CODE_WITH_YOUR_APP:
    'Scan the image in your bank’s app, then type the code here.',
  SELECT_ACCOUNT: 'Select your account',
  SELECT_AUTHENTICATION_METHOD: 'Select authentication method',
  SELECT_AUTHENTICATION_METHOD_DISABLED_REASON:
    'Select authentication method to continue',
  SELECTED_BANK_DETAILS: 'Selected bank details',
  SHOW_PASSWORD: 'Show password / PIN',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  SUBJECT:
    CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS ? 'account access' : 'payment',
  SUBMIT_AND_CANCEL_PAYMENT: 'Submit and cancel $t(SUBJECT)',
  SUBMITTING_CANCEL: 'Cancelling - Please wait',
  SUBMITTING_LOGIN: 'Logging in - Please wait',
  SUBMITTING_VERIFICATION_CODE: 'Submitting authentication code - Please wait.',
  SUBMITTING_VERIFICATION_METHOD:
    'Submitting verification method - Please wait.',
  TAP_THE_PUSH_NOTIFICATION_FROM: 'You should receive a push notification.',
  TO_IMPROVE_YOUR_NEXT_EXPERIENCE:
    'To improve your next experience, we’d love to understand why you want to cancel.',
  UNAUTHORISED_LOGIN:
    'The provided institutional login information is invalid.',
  UNAUTHORISED_VERIFICATION: 'The specified SCA code is invalid.',
  USER: 'Username',
  VERIFICATION_CODE: 'Verification code',
  VERIFICATION_VIEW_TITLE: 'Verification',
  VERIFY: 'Verify',
  VERIFY_PAYMENT: 'Verify $t(SUBJECT)',
  VOLT_SCA: 'Volt SCA',
  WAITING_FOR_VERIFICATION_VIEW_TITLE: 'Waiting for verification',
  WAITING_FOR_VERIFY_STATUS: 'Waiting for verification status and redirect',
  YOUR_CODE_IS_DISPLAYED_IN_PUSHTAN_APP:
    'Your code is displayed in your PushTAN app or on a SMS on your phone.',
} as const;
